export default "__VITE_PUBLIC_ASSET__e90358c0__"